import { useSearchParams } from 'next/navigation'

import { UI_QUERY_PARAMS } from '@/constants/common'

function useUIQueryParams() {
  const searchParams = useSearchParams()

  const uiParams: Record<string, string> = {}

  UI_QUERY_PARAMS.forEach((key) => {
    const value = searchParams.get(key)
    if (value !== null) {
      uiParams[key] = value
    }
  })

  return uiParams
}

export default useUIQueryParams
